export const MAX_PHONE_MIN_DIMENSION = 480;
export const MAX_TABLET_MIN_DIMENSION = 1024;
export const MAX_TABLET_MAX_DIMENSION = 1366;
export const DEFAULT_ROTATE_PROMPT_MAX_WIDTH = 767;

export function isPhoneScreen(screenWidth: number, screenHeight: number): boolean {
  const min = Math.min(Number(screenWidth) || 0, Number(screenHeight) || 0);
  return min > 0 && min <= MAX_PHONE_MIN_DIMENSION;
}

export function isPhoneOrTabletScreen(args: {
  screenWidth: number;
  screenHeight: number;
  maxTouchPoints?: number;
  userAgent?: string;
}): boolean {
  if (isPhoneScreen(args.screenWidth, args.screenHeight)) {
    return true;
  }

  const userAgent = String(args.userAgent || "");
  if (/iPad|Android(?!.*Mobile)|Tablet/i.test(userAgent)) {
    return true;
  }
  if (/Macintosh/i.test(userAgent) && Number(args.maxTouchPoints || 0) > 1) {
    return true;
  }

  const width = Number(args.screenWidth) || 0;
  const height = Number(args.screenHeight) || 0;
  const min = Math.min(width, height);
  const max = Math.max(width, height);
  const isTouch = Number(args.maxTouchPoints || 0) > 0;
  return isTouch
    && min >= 481
    && min <= MAX_TABLET_MIN_DIMENSION
    && max <= MAX_TABLET_MAX_DIMENSION;
}

export function isPhoneOrTabletDevice(): boolean {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return false;
  }

  return isPhoneOrTabletScreen({
    screenWidth: window.screen?.width ?? 0,
    screenHeight: window.screen?.height ?? 0,
    maxTouchPoints: navigator.maxTouchPoints ?? 0,
    userAgent: navigator.userAgent ?? "",
  });
}

export function shouldShowRotatePromptFromMetrics(args: {
  viewportWidth: number;
  viewportHeight: number;
  screenWidth: number;
  screenHeight: number;
  rotatePromptMaxWidth?: number | null;
}): boolean {
  const rotatePromptMaxWidth = Number.isFinite(args.rotatePromptMaxWidth)
    ? Number(args.rotatePromptMaxWidth)
    : DEFAULT_ROTATE_PROMPT_MAX_WIDTH;
  const isPortrait = args.viewportHeight > args.viewportWidth;
  const isPhoneWidth = args.viewportWidth <= rotatePromptMaxWidth;
  return (isPhoneWidth || isPhoneScreen(args.screenWidth, args.screenHeight)) && isPortrait;
}
